var t,e;function s(){if(e)return t;e=1;return t=class{constructor(t,e){this.authId=t,this.hostName=e}sign(t){t.parameters.key=this.authId,this.hostName&&(t.headers.Referer="https://"+this.hostName)}}}export{s as __require};
